import { Shield, CheckCircle, Users, HeadphonesIcon } from "lucide-react";

const TrustRibbon = () => {
  return (
    <div className="w-full bg-gradient-to-r from-primary via-primary-foreground/10 to-primary py-3 px-4 md:px-6">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-accent" />
            <span className="font-semibold text-primary-foreground">
              Neil AI Global Solutions LLC
            </span>
            <span className="text-primary-foreground/80">•</span>
            <span className="text-primary-foreground/90 text-sm">
              Verified AI & Robotics Automation Provider
            </span>
          </div>
          <p className="text-xs text-primary-foreground/75">
            Serving real businesses, schools, churches & organizations across North Carolina and beyond.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-xs text-primary-foreground">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse shadow-[0_0_8px_rgba(74,222,128,0.7)]" />
            SSL Secured
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-xs text-primary-foreground">
            <CheckCircle className="w-3 h-3" />
            Verified Business
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-xs text-primary-foreground">
            <Users className="w-3 h-3" />
            Official Robotics Dealer
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-accent/40 bg-background/10 backdrop-blur-sm text-xs text-primary-foreground">
            <HeadphonesIcon className="w-3 h-3" />
            Human Support & Training
          </span>
        </div>
      </div>
    </div>
  );
};

export default TrustRibbon;
